const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://088s3oi4a8.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://8d4wyy4iub.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.teck.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.teck.forwoodsafety.com'
  }
};

export default config;